"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderUpdateSchema = exports.OrderSchema = void 0;
const zod_1 = require("zod");
const _1 = require(".");
const __1 = require("..");
const base_promotion_1 = require("../promotion/base-promotion");
exports.OrderSchema = __1.BaseSchema.extend({
    buyer: _1.BuyerSchema,
    channel: __1.ChannelSchema.partial().required({ id: true }),
    channelAdditionalData: zod_1.z.object({}).optional(),
    channelOrderId: __1.ShortStringSchema,
    channelOrderDetailsUrl: __1.LongStringSchema.url().optional(),
    channelOrderUrl: __1.LongStringSchema.url().optional(),
    channelOrderMessagesUrl: __1.LongStringSchema.url().optional(),
    channelCancelOrderUrl: __1.LongStringSchema.url().optional(),
    channelRefundOrderUrl: __1.LongStringSchema.url().optional(),
    channelUploadOrderInvoiceUrl: __1.LongStringSchema.url().optional(),
    channelShippingLabelUrl: __1.LongStringSchema.url().optional(),
    channelStatus: __1.ShortStringSchema.optional(),
    /**
     * Total amount of the discounts applied to the order. It considers item promotions, order promotions, and additional discounts.
     */
    discountTotal: __1.MoneySchema.optional(),
    earliestDeliveryAt: zod_1.z.coerce.date().optional(),
    earliestShipAt: zod_1.z.coerce.date().optional(),
    expiresAt: zod_1.z.coerce.date().optional(),
    items: zod_1.z.array(_1.OrderItemSchema),
    promotion: base_promotion_1.BasePromotionSchema.omit({ ads: true, video: true }).optional(),
    salesperson: __1.SalespersonSchema.pick({ id: true, name: true }).optional(),
    /**
     * Total amount of the items price. It considers promotional item discounts and changes to the item price that happened in the order.
     */
    itemPriceTotal: __1.MoneySchema.optional(),
    /**
     * Original price of the items before any discount is applied. It does not consider the shipping price.
     */
    itemDiscountTotal: __1.MoneySchema.optional(),
    /**
     * Additional discount the seller can apply to the order. It is not related to any promotional discount.
     */
    additionalDiscount: __1.MoneySchema.optional(),
    itemTaxTotal: __1.MoneySchema.optional(),
    latestDeliveryAt: zod_1.z.coerce.date().optional(),
    latestShipAt: zod_1.z.coerce.date().optional(),
    numberOfItems: zod_1.z.number(),
    /**
     * Total price to the order, including applied discounts (item promotions, order promotions, additional discounts) and the shipping price.
     */
    orderTotal: __1.MoneySchema.optional(),
    orderType: zod_1.z.nativeEnum(__1.OrderType).optional(),
    payments: zod_1.z.array(_1.OrderPaymentSchema),
    /**
     * Total amount of the discounts applied to the order. It considers only order promotions.
     */
    promotionDiscount: __1.MoneySchema.optional(),
    saleFeeTotal: __1.MoneySchema.optional(),
    shipment: _1.ShipmentSchema.optional(),
    shippingDiscountTotal: __1.MoneySchema.optional(),
    shippingDiscountTaxTotal: __1.MoneySchema.optional(),
    /**
     * Total amount of shipping price applied to the order.
     */
    shippingPriceTotal: __1.MoneySchema.optional(),
    shippingTaxTotal: __1.MoneySchema.optional(),
    status: zod_1.z.nativeEnum(__1.OrderStatus),
    readAt: zod_1.z.coerce.date().optional(),
    readBy: __1.UserSchema.optional(),
    store: __1.BaseStoreSchema.omit({
        storefrontPreferences: true,
        lastFeedback: true,
        cancellationReasonDetails: true,
    })
        .partial()
        .required({ id: true }),
    /**
     * @description Anything the buyer would like to note about the order. Shipment details, address, payment method, etc.
     */
    buyerNotes: __1.MediumStringSchema.optional(),
    /**
     * @description Anything the seller would like to note about the order. Shipment details, address, payment method, etc.
     */
    sellerNotes: __1.MediumStringSchema.optional(),
    source: zod_1.z.nativeEnum(__1.OrderSource).optional(),
    itemWeightTotal: __1.WeightSchema.optional(),
});
exports.OrderUpdateSchema = zod_1.z.object({
    channelId: __1.ShortStringSchema,
    channelOrderId: __1.ShortStringSchema,
    id: __1.ShortStringSchema,
    isOrderNew: zod_1.z.boolean(),
    items: _1.OrderItemsChangeSchema,
    oldOrderStatus: zod_1.z.nativeEnum(__1.OrderStatus).optional(),
    status: zod_1.z.nativeEnum(__1.OrderStatus),
    storeId: __1.ShortStringSchema,
    updateTypes: zod_1.z.array(zod_1.z.nativeEnum(__1.OrderUpdateType)),
});
//# sourceMappingURL=order.js.map